import { Urls } from './urls'

export const Params = {

    LOGIN_POST: {
        endpoint: 'app',
        csurl: Urls.ONLINE_PROXY
    },

    MY_NOTIFICATIONS_POST: {
        endpoint: 'usuarios/asignaciones',
        csurl: Urls.ONLINE_PROXY
    },

    NEAR_NOTIFICATIONS_POST: {
        endpoint: 'usuarios/cercanas',
        csurl: Urls.ONLINE_PROXY
    },

    SAVE_NOTIFICATION_POST: {
        endpoint: 'visitas/guardar',
        csurl: Urls.ONLINE_PROXY
    },

    CUSTOMER_SERVICE_CENTERS_POST: {
        endpoint: 'areas/cacs',
        csurl: Urls.ONLINE_PROXY
    },

    UPDATE_PASSWORD_POST: {
        endpoint: 'aplicaciones/password',
        csurl: Urls.ONLINE_PROXY
    },

    HISTORY_POST: {
        endpoint: 'usuarios/historial',
        csurl: Urls.ONLINE_PROXY
    },
}
